export default "__VITE_ASSET__CzUEZYEX__"